import * as React from 'react'
function SvgCurrencyYen(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M26.8 24.667h-5.6V22.8h5.6c1.12 0 1.867-.747 1.867-1.867s-.747-1.866-1.867-1.866h-5.04l6.533-8.214c.56-.746.56-2.053-.373-2.613-.747-.56-2.053-.56-2.613.373l-5.974 7.467-5.973-7.467c-.56-.746-1.867-.933-2.613-.373-.747.56-.934 1.867-.374 2.613l6.534 8.214h-5.04c-1.12 0-1.867.746-1.867 1.866s.747 1.867 1.867 1.867h5.6v1.867h-5.6c-1.12 0-1.867.746-1.867 1.866s.747 1.867 1.867 1.867h5.6v3.733c0 1.12.746 1.867 1.866 1.867s1.867-.747 1.867-1.867V28.4h5.6c1.12 0 1.867-.747 1.867-1.867s-.747-1.866-1.867-1.866z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgCurrencyYen
